import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Modal,
  Row,
} from "react-bootstrap";
import "./CertificateList.css";
import { Table } from "antd";
import { IoEyeOutline } from "react-icons/io5";
import PostApiCall from "../../../helpers/PostApi";
import Notiflix from "notiflix";
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import moment from "moment";
import { BsTrash } from "react-icons/bs";
const columns = [
  {
    title: "Certificate Number",
    dataIndex: "certificateNumber",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Mobile Number",
    dataIndex: "mobile",
  },
  {
    title: "Number of Viewers",
    dataIndex: "downloads",
  },
  {
    title: "Last Updated On",
    dataIndex: "updatedon",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const viewsColumns = [
  {
    title: "Certificate Number",
    dataIndex: "certificateNumber",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Mobile Number",
    dataIndex: "mobile",
  },
  // {
  //   title: "View",
  //   dataIndex: "downloads",
  // },
  {
    title: "Last Viewd On",
    dataIndex: "updatedon",
  }
];
const CertificateList = () => {
  const navigate = useNavigate();
  const [certificates, setCertificates] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenViewsModal, setIsOpenViewsModal] = useState(false);
  const [viewsData, setViewsData] = useState([]);
  const [selectedImg, setSelectedImg] = useState("");
  const handleToggleModal = () => {
    setIsOpen(false);
    setSelectedImg("");
  };
  const users = certificates?.map((data) => {
    return {
      id: data?.fld_id,
      name: data?.fld_name,
      email: data?.fld_email,
      mobile: data?.fld_mobile,
      certificateNumber: data?.fld_certificate_number,
      downloads: (
        data?.fld_downloads_count ?
          <div className="d-flex align-items-center gap-3">
            {data?.fld_downloads_count
              ? data?.fld_downloads_count +
              data?.fld_downloads_count
              : "-"}
            <Button
              variant="light"
              size="sm"
              className="d-flex align-items-center gap-1 px-1 py-0"
              type="button"
              onClick={() => {
                setViewsData(data?.certificate_views || []);
                setIsOpenViewsModal(true);
              }}
            >
              <IoEyeOutline /> View
            </Button></div> : "-")
      ,
      updatedon: data?.fld_updatedon
        ? moment(data?.fld_updatedon)?.format("DD-MM-YYYY")
        : "-",
      action: (
        <div className="d-flex gap-3">
          <Button
            variant="light"
            className="d-flex"
            type="button"
            onClick={() => {
              setSelectedImg(data?.fld_certificate_url);
              setIsOpen(true);
            }}
          >
            <IoEyeOutline />
          </Button>
          <Button
            variant="light"
            className="d-flex"
            type="button"
            onClick={() =>
              navigate(`/admin/addcertificate`, {
                state: { certificateData: data },
              })
            }
          >
            <FaEdit />
          </Button>
          <Button
            variant="light"
            className="d-flex"
            type="button"
            onClick={() => DeleteCertificate(data)}
          >
            <BsTrash />
          </Button>
        </div>
      ),
      certificateUrl: data?.fld_certificate_url,
      allData: data,
    };
  });
  const certificateViews = viewsData?.length > 0 ? JSON.parse(viewsData).map((data, i) => {
    return {
      id: i + 1,
      name: data?.fld_name,
      mobile: data?.fld_mobile,
      certificateNumber: data?.fld_certificate_number,
      downloads: data?.fld_downloads_count
        ? data?.fld_downloads_count +
        data?.fld_downloads_count
        : "-",
      updatedon: data?.fld_createdon
        ? moment(data?.fld_createdon)?.format("DD-MM-YYYY h:mm:ss a")
        : "-",
    };
  }) : [];
  useEffect(() => {
    GetCertificateList();
  }, []);
  const GetCertificateList = () => {
    Notiflix.Loading.dots();
    PostApiCall.postRequest(
      {
        whereClause: "",
      },
      "GetCertificateList"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status === 200 || result.status === 201) {
          setCertificates(
            obj?.data?.filter((data) => data?.fld_status !== "Deleted")
          );
          Notiflix.Loading.remove();
        } else {
          Notiflix.Loading.remove();
          Notiflix.Notify.failure("");
        }
      })
    );
  };
  const DeleteCertificate = (data) => {
    try {
      Notiflix.Loading.dots();
      PostApiCall.postRequest(
        {
          id: data?.fld_id,
          name: data?.fld_name,
          certificate: data?.fld_certificate_number,
          mobile: data?.fld_mobile,
          email: data?.fld_email,
          certificateurl: data?.fld_certificate_url,
          status: "Deleted",
        },
        "AddCertificate"
      ).then((result) =>
        result.json().then((obj) => {
          if (result.status === 200 || result.status === 201) {
            GetCertificateList();
            Notiflix.Notify.success("Certificate deleted successfully.");
            Notiflix.Loading.remove();
            navigate("/admin/certificatelist");
          } else {
            Notiflix.Loading.remove();
            Notiflix.Notify.failure(obj?.data);
          }
        })
      );
    } catch (err) {
      console.log(err);
      Notiflix.Loading.remove();
    }
  };
  return (
    <>
      <section className="certificate-section section-spacing-x">
        <Container fluid>
          <div className="certificate-list">
            <div className="section-bootom-border pb-4 mb-4">
              <h1 className="text-start text-white mb-0">Certificate List</h1>
            </div>

            <Table
              columns={columns}
              dataSource={users}
              size="larger"
              className="certificate-table d-none d-lg-block w-100"
            />
            <Row className="d-block d-lg-none">
              {users.map((user) => (
                <Col lg={6} key={user?.id} className="mb-3">
                  <Card className="certificateList-card">
                    <CardHeader className="p-3">
                      <h4 className="mb-0">{user?.certificateNumber}</h4>
                    </CardHeader>
                    <CardBody className="p-3">
                      <div className="card-item d-flex gap-2 mb-2">
                        <span className="fw-500">Name -</span>
                        <span>{user?.name}</span>
                      </div>
                      <div className="card-item d-flex gap-2 mb-2">
                        <span className="fw-500">Mobile -</span>
                        <span>+91 {user?.mobile}</span>
                      </div>
                      <div className="card-item d-flex gap-2">
                        <span className="fw-500">Email -</span>
                        <span>{user?.email}</span>
                      </div>
                      <div className="card-item d-flex gap-2 flex-wrap mt-2">
                        <span className="fw-500">Number of Viewers</span>
                        {user?.allData?.fld_downloads_count ?
                          <div className="d-flex align-items-center gap-3">
                            {user?.allData?.fld_downloads_count
                              ? user?.allData?.fld_downloads_count +
                              user?.allData?.fld_downloads_count
                              : "-"}
                            <Button
                              variant="light"
                              size="sm"
                              className="d-flex align-items-center gap-1 px-1 py-0"
                              type="button"
                              onClick={() => {
                                setViewsData(user?.allData?.certificate_views || []);
                                setIsOpenViewsModal(true);
                              }}
                            >

                              <IoEyeOutline /> View
                            </Button>
                          </div> :
                          <span className="fw-500">Views - 0</span>}
                      </div>
                    </CardBody>
                    <CardFooter className="p-3 text-center d-flex gap-3">
                      <Button
                        variant="light w-50"
                        type="button"
                        onClick={() => {
                          setSelectedImg(user?.certificateUrl);
                          setIsOpen(true);
                        }}
                      >
                        <IoEyeOutline />
                      </Button>
                      <Button
                        variant="light w-50"
                        type="button"
                        onClick={() =>
                          navigate(`/admin/addcertificate`, {
                            state: { certificateData: user?.allData },
                          })
                        }
                      >
                        <FaEdit />
                      </Button>
                      <Button
                        variant="light w-50"
                        type="button"
                        onClick={() => DeleteCertificate(user?.allData)}
                      >
                        <BsTrash />
                      </Button>
                    </CardFooter>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </section>
      <Modal
        show={isOpen}
        centered
        onHide={() => {
          handleToggleModal();
        }}
      >
        <Modal.Header
          closeButton
          className="border-0 p-2 position-absolute right-0 bg-white z-3 top-0 end-0"
        />
        <Modal.Body className="p-2 d-flex justify-content-center">
          <>
            <img
              src={selectedImg || ""}
              className="img-fluid"
              alt="Preview"
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none", pointerEvents: "auto" }}
              draggable={false}
            />
          </>
        </Modal.Body>
      </Modal>
      <Modal
        show={isOpenViewsModal}
        centered
        size="lg"
        onHide={() => {
          setIsOpenViewsModal(false)
        }}
      >
        <Modal.Header
          closeButton
        // className="border-0 p-2 position-absolute right-0 bg-white z-3 top-0 end-0"
        ><Modal.Title className="mb-0">People Who Viewed</Modal.Title> </Modal.Header>
        <Modal.Body className="p-2 d-flex justify-content-center">
          <>
            {window.innerWidth > 768 ?
              <Table
                columns={viewsColumns}
                dataSource={certificateViews}
                size="larger"
                bordered
                className=" d-none d-lg-block w-100"
              />
              :
              <div className="d-block d-lg-none w-100 px-2 pt-0">
                {certificateViews?.map((user) => (
                  <div key={user?.id} className="mt-3
                  ">
                    <Card className="">
                      <CardHeader className="p-3">
                        <h4 className="mb-0">{user?.certificateNumber}</h4>
                      </CardHeader>
                      <CardBody className="p-3">
                        <div className="card-item d-flex gap-2 mb-2">
                          <span className="fw-500">Name -</span>
                          <span>{user?.name}</span>
                        </div>
                        <div className="card-item d-flex gap-2 mb-2">
                          <span className="fw-500">Mobile -</span>
                          <span>+91 {user?.mobile}</span>
                        </div>
                        {/* <div className="card-item d-flex gap-2 mb-2">
                          <span className="fw-500">Views -</span>
                          <span>{user?.downloads}</span>
                        </div> */}
                        <div className="card-item d-flex gap-2 mb-2">
                          <span className="fw-500">Viewed on -</span>
                          <span>{user?.updatedon}</span>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                ))}
              </div>
            }
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CertificateList;
